import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { Mail, Phone, Send, MessageSquare } from 'lucide-react';
import { toast } from 'sonner';
import emailjs from '@emailjs/browser';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await emailjs.send(
        'service_w5hg1vh',
        'template_3ncb285',
        {
          from_name: formData.name,
          from_company: formData.company,
          from_email: formData.email,
          from_phone: formData.phone,
          message: formData.message,
        },
        '-lanfvBizXzjzBsPN'
      );

      toast.success('Mensagem enviada com sucesso! Entraremos em contato em breve.');
      setFormData({
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      console.error('Erro ao enviar mensagem:', error);
      toast.error('Erro ao enviar mensagem. Por favor, tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contato" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-sm uppercase tracking-wider">Entre em Contato</span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-bold text-gray-900">
            Fale com a SSA DISTRIBUIDORA
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Tire suas dúvidas, solicite informações ou envie sugestões. Nossa equipe está pronta para atendê-lo.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div className="space-y-6">
            <Card className="p-6 hover:shadow-lg transition-all duration-300 border-l-4 border-l-gray-700">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                  <Phone className="text-gray-700" size={24} />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-bold text-gray-900 mb-1">Telefone</h3>
                  <p className="text-gray-600 text-sm mb-2">Ligue para nossa equipe</p>
                  <a href="tel:+5521996772772" className="text-gray-700 hover:text-gray-900 font-semibold inline-block">
                    +55 (21) 99677-2772
                  </a>
                </div>
              </div>
            </Card>

            <Card className="p-6 hover:shadow-lg transition-all duration-300 border-l-4 border-l-red-600">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                  <Mail className="text-red-600" size={24} />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-bold text-gray-900 mb-1">E-mail</h3>
                  <p className="text-gray-600 text-sm mb-2">Envie sua mensagem</p>
                  <a href="mailto:vendas@ssapecas.com.br" className="text-red-600 hover:text-red-700 font-semibold inline-block break-all text-sm">
                    vendas@ssapecas.com.br
                  </a>
                </div>
              </div>
            </Card>

            <Card className="p-6 hover:shadow-lg transition-all duration-300 border-l-4 border-l-gray-700">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                  <MessageSquare className="text-gray-700" size={24} />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-bold text-gray-900 mb-1">Horário</h3>
                  <p className="text-gray-600 text-sm mb-2">Segunda à Sexta</p>
                  <p className="text-gray-700 font-semibold">08:00 - 18:00</p>
                </div>
              </div>
            </Card>

            <Card className="p-6 bg-red-50 border-l-4 border-l-red-600">
              <div className="flex items-start">
                <svg className="w-12 h-12 text-red-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                </svg>
                <div className="ml-4">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Compras Online</h3>
                  <p className="text-gray-700 text-sm mb-3">
                    Para cotações e pedidos, acesse nossa loja virtual
                  </p>
                  <a
                    href="https://www.vhsys.net/ssadistribuidora"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-red-600 hover:text-red-700 font-semibold text-sm"
                  >
                    Acessar Loja
                    <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </a>
                </div>
              </div>
            </Card>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2">
            <Card className="p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Envie sua Mensagem</h3>
              <p className="text-gray-600 mb-6">Preencha o formulário abaixo e entraremos em contato em breve</p>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                      Nome Completo *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-700 focus:border-transparent transition-all duration-200"
                      placeholder="Seu nome" />

                  </div>
                  <div>
                    <label htmlFor="company" className="block text-sm font-semibold text-gray-700 mb-2">
                      Empresa *
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      required
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-700 focus:border-transparent transition-all duration-200"
                      placeholder="Nome da empresa" />

                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                      E-mail *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-700 focus:border-transparent transition-all duration-200"
                      placeholder="seu@email.com" />

                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                      Telefone *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-700 focus:border-transparent transition-all duration-200"
                      placeholder="(00) 0000-0000" />

                  </div>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                    Mensagem *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    value={formData.message}
                    onChange={handleChange}
                    rows="6"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-700 focus:border-transparent transition-all duration-200 resize-none"
                    placeholder="Como podemos ajudar? Descreva sua dúvida ou solicitação..." />

                </div>

                <Button
                  type="submit"
                  size="lg"
                  disabled={isSubmitting}
                  className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-4 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed">

                  {isSubmitting ?
                  <span className="flex items-center justify-center">
                      <svg className="animate-spin h-5 w-5 mr-2" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Enviando...
                    </span> :

                  <>
                      <Send className="mr-2" size={20} />
                      Enviar Mensagem
                    </>
                  }
                </Button>
              </form>
            </Card>
          </div>
        </div>
      </div>
    </section>);

};